type FormElement<TValue> = {
    value: TValue;
    errorMessage?: string;
};

export default FormElement;

export function formElement<TValue>(value: TValue): FormElement<TValue> {
    const element: FormElement<TValue> = {
        value: value,
        errorMessage: ""
    };

    return element;
}
